module.exports = app_owpp_realEstateValueLandingPage;